<template>
  <div class="typelist" @click="itemClick($event)">
    <div class="typelist-detail" :class="align">
      <span :class="icon" style="font-size: 0.67rem;display: inline-block;"><span class="name" :style="{color: color}">{{name}}</span></span>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      name: {
        type: String,
        default: '未曾遗忘的青春'
      },
      clickItem: {
        type: Function,
        default: undefined
      },
      action: {
        type: String,
        default: 'preview'
      },
      type: {
        type: String,
        default: 'router'
      },
      border: {
        type: Boolean,
        default: true
      },
      icon: {
        type: String
      },
      color: {
        type: String
      },
      align: {
        type: String,
        default: 'center'
      }
    },
    methods: {
      itemClick () {
        this.clickItem({action: this.action, type: this.aType, name: this.name})
      }
    }
  }
</script>
<style lang="stylus" rel="stylesheet/stylus">
  .typelist
    margin: 0 auto
    width: 9.46rem
    height: 1rem
    line-height: 1rem
    background: color
    position: relative
    .info
      font-size: 0.4rem
      position: absolute
      top: 50%
      color: $primarycolor
      left: 1.6rem
      height: 100%;
      line-height: 1rem
      transform: translate(0, -50%)
    .center
      text-align: center
    .left
      text-align: left
    .typelist-detail
      width: 100%
      height: 100%
      /*line-height: 1rem*/
      .name
        font-size: 0.45rem
        margin-left: 0.1rem
        vertical-align: bottom
        display: inline-block
</style>



// WEBPACK FOOTER //
// menu_item.vue?49cf8424